{
  "common.close": "Chiudi",
  "common.athleteFallback": "atleta {id}",
  "splash.title": "{app} — visualizzazione animata delle attività",
  "splash.tagline": "I tuoi dati Strava&nbsp;in movimento",
  "splash.demo": "Demo",
  "tab.query.title": "Mappa di {name}",
  "tab.query.heading": "Ricerca attività:",
  "tab.query.optDays": "ultimi giorni",
  "tab.query.optActivities": "ultime attività",
  "tab.query.optIds": "ID attività",
  "tab.query.optDates": "Intervallo di date",
  "tab.query.idsPlaceholder": "inserisci qui gli ID delle attività",
  "tab.query.after": "Dal:",
  "tab.query.before": "Al:",
  "tab.query.autozoom": "Zoom automatico <i class=\"hf hf-bullseye\"></i> sulla ricerca dopo l'importazione",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> Cerca",
  "tab.query.createAccount": "Crea un account oppure accedi.",
  "tab.query.sports": "Sport:",
  "tab.query.allSports": "Tutti gli sport",
  "tab.query.sportsExcept": "Tutti tranne",
  "tab.query.sportsNone": "Nessuno",
  "tab.query.loadingSports": "Caricamento degli sport…",
  "tab.query.sportsFailed": "Impossibile caricare gli sport di questa mappa",
  "tab.query.noSports": "Ancora nessuna attività",
  "tab.activities.title": "Attività visualizzate",
  "tab.activities.clearSelection": "Annulla selezione",
  "tab.activities.renderSelected": "Mostra selezione",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> Zoom sulla selezione",
  "tab.controls.title": "Impostazioni livello",
  "tab.controls.timescale": "Scala temporale <i>&tau;</i>",
  "tab.controls.timescaleHint": "velocità di riproduzione",
  "tab.controls.period": "Periodo <i>T</i>",
  "tab.controls.periodHint": "attività ~ modello",
  "tab.controls.dotSize": "Dimensione dei punti",
  "tab.controls.pathWidth": "Spessore dei tracciati",
  "tab.controls.pathWidthHint": "zero nasconde i tracciati",
  "tab.controls.colors": "Colori",
  "tab.controls.colorsHint": "ruota la tavolozza",
  "tab.controls.shadows": "Ombre",
  "tab.profile.loginTitle": "Accedi",
  "tab.profile.anonNote": "Accedi con Strava per vedere le tue attività e gestire il tuo account Heatflask.",
  "tab.profile.loginLink": "Accedi con Strava",
  "tab.profile.editOnStrava": "Modifica il tuo profilo su Strava",
  "tab.profile.indexNote": "Indicizziamo i riepiloghi delle tue attività per un accesso rapido.",
  "tab.profile.viewIndex": "Vedi indice",
  "tab.profile.sharedMaps": "Mappe condivise",
  "tab.profile.sharedMapsNote": "Disattivato: solo tu puoi vedere le tue attività su Heatflask. Attivato: chiunque abbia un link alla tua mappa può vedere le attività che hai reso pubbliche su Strava. Quelle private restano tue in ogni caso. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">Come funziona la privacy</a>",
  "tab.profile.logout": "Esci",
  "tab.profile.deleteAccount": "Elimina account",
  "tab.profile.deleteConfirm": "Eliminare il tuo account Heatflask?\n\nVerranno rimosse le attività indicizzate e revocato l'accesso di Heatflask ai tuoi dati Strava. L'operazione è irreversibile.",
  "tab.profile.languageHeading": "Lingua",
  "tab.profile.languageAuto": "Automatico",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">Aiutaci a correggere o ad aggiungere traduzioni!</a>",
  "tab.profile.unitsHeading": "Unità",
  "tab.profile.unitsAuto": "Automatico",
  "tab.profile.unitsMetric": "Metrico (km, m)",
  "tab.profile.unitsImperial": "Imperiale (mi, ft)",
  "tab.profile.textSizeHeading": "Dimensione del testo",
  "tab.profile.textSmaller": "Più piccolo",
  "tab.profile.textReset": "Normale",
  "tab.profile.textLarger": "Più grande",
  "tab.profile.mapDefaultsHeading": "Impostazioni predefinite della mappa",
  "tab.profile.mapDefaultsNote": "Inizia con questa mappa di base, questo rilievo e queste impostazioni del livello ogni volta che apri una mappa il cui link non imposta le proprie. I link che condividi mostrano comunque esattamente ciò che vedi.",
  "tab.profile.mapDefaultsSave": "Salva come mie predefinite",
  "tab.profile.mapDefaultsForget": "Dimentica",
  "tab.info.title": "Info",
  "tab.info.controlsHeading": "Comandi",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + trascina",
  "tab.info.shiftDragDesc": "Seleziona le attività dentro un riquadro. Su schermo touch tocca prima <i class=\"hf-object-group\"></i>, poi trascina con un dito. L'ultima attività selezionata ne mostra i dettagli, e l'elenco scorre fino a lei.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + trascina",
  "tab.info.ctrlDragDesc": "Ruota e inclina la mappa in 3D, oppure usa due dita",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "Apri o chiudi la barra laterale",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "Scheda precedente o successiva",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "Chiudi la barra laterale",
  "tab.info.liveUrlHeading": "URL dinamico",
  "tab.info.liveUrlDesc": "La vista della mappa e le impostazioni dell'animazione sono conservate nell'URL della pagina, così chi la riceve vede esattamente la stessa cosa.",
  "tab.info.videoHeading": "Esportazione video",
  "tab.info.videoDesc": "Il pulsante <i class=\"hf-video-camera\"></i> registra l'animazione in MP4: toccalo, dimensiona il riquadro sulla parte di mappa che vuoi e toccalo di nuovo per registrare. Viene registrato un giro completo dell'animazione, così il video si ripete senza stacchi; un giro più lungo di {max} secondi (il video più lungo accettato da Strava) viene tagliato a {max}.",
  "tab.info.contributeHeading": "Contribuisci",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> Diventa sponsor su GitHub",
  "tab.info.contactsHeading": "Contatti",
  "map.basemapAndTerrain": "Mappa di base e rilievo",
  "map.pauseAnimation": "Metti in pausa l'animazione",
  "map.resumeAnimation": "Riprendi l'animazione",
  "capture.record": "Registra video (ciclo di {period} s)",
  "capture.recordTruncated": "Registra video (un ciclo dura {period} s; verranno registrati solo i primi {max} s)",
  "capture.recordArea": "Registra l'area dentro il riquadro",
  "capture.stop": "Ferma la registrazione",
  "capture.selectionTooSmall": "la selezione è troppo piccola",
  "capture.saved": "{name} salvato ({size})",
  "capture.cancelled": "registrazione annullata",
  "capture.failed": "registrazione non riuscita: {error}",
  "capture.loadingEncoder": "caricamento del codificatore…",
  "capture.waitingForMap": "in attesa del caricamento della mappa…",
  "capture.encoding": "codifica… {percent} %",
  "capture.finalizing": "completamento…",
  "share.title": "Condividi un link a questa mappa",
  "share.copied": "link copiato",
  "share.copiedUnshared": "link copiato, ma la tua mappa non è condivisa, quindi nessun altro può aprirla. Attiva «Mappe condivise» per cambiare.",
  "share.unshared": "La tua mappa non è condivisa, quindi nessun altro può aprire questo link. Attiva «Mappe condivise» per cambiare.",
  "share.copyThis": "Copia questo link:",
  "update.available": "È disponibile una nuova versione di Heatflask.",
  "update.reload": "Ricarica",
  "import.title": "Importazione",
  "import.stop": "Ferma",
  "import.stopping": "interruzione…",
  "import.contacting": "connessione a Strava…",
  "import.countOf": "Attività: {received} di {total}",
  "import.count": "Attività: {received}",
  "import.waitStrava": "In pausa fino alle {time} per il limite di download di Strava. Lascia aperta questa pagina; ricaricare non accelera.",
  "import.waitRationed": "Hai esaurito i download veloci di oggi. Il resto riprende alle {time}, più lentamente. Lascia aperta questa pagina.",
  "import.dailyLimit": "Il limite giornaliero di download di Strava è esaurito. Riprova dopo le {time}.",
  "import.dailyRationed": "Hai usato la tua quota di download da Strava per oggi. Riprova dopo le {time}.",
  "import.noActivitiesYet": "Il tuo account Strava non ha ancora attività. Registrane o caricane una su Strava e comparirà qui.",
  "table.noActivities": "nessuna attività",
  "table.untitled": "(senza titolo)",
  "activities.pageTitle": "{app} — indice delle attività",
  "activities.heading": "Indice delle attività",
  "activities.fetching": "Recupero delle attività...",
  "activities.rateLimit": "Limite di richieste Strava raggiunto; si riprende alle {time}",
  "activities.noData": "Spiacenti, nessun dato &#128577;",
  "activities.colServerCache": "Tracciato in cache sul server (Mongo)",
  "activities.colBrowserCache": "Tracciato in cache in questo browser",
  "activities.cachedServer": "Il tracciato di {id} è in cache sul server",
  "activities.notCachedServer": "Il tracciato di {id} non è in cache sul server",
  "activities.cachedBrowser": "Il tracciato di {id} è in cache in questo browser",
  "activities.notCachedBrowser": "Il tracciato di {id} non è in cache in questo browser",
  "sport.AlpineSki": "Sci alpino",
  "sport.BackcountrySki": "Scialpinismo",
  "sport.Badminton": "Badminton",
  "sport.Basketball": "Pallacanestro",
  "sport.Canoeing": "Canoa",
  "sport.Cricket": "Cricket",
  "sport.Crossfit": "Crossfit",
  "sport.Dance": "Danza",
  "sport.EBikeRide": "Giro in e-bike",
  "sport.Elliptical": "Ellittica",
  "sport.EMountainBikeRide": "Giro in e-MTB",
  "sport.Golf": "Golf",
  "sport.GravelRide": "Giro gravel",
  "sport.Handcycle": "Handbike",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "Escursione",
  "sport.IceSkate": "Pattinaggio su ghiaccio",
  "sport.InlineSkate": "Pattinaggio in linea",
  "sport.Kayaking": "Kayak",
  "sport.Kitesurf": "Kitesurf",
  "sport.MountainBikeRide": "Giro in MTB",
  "sport.NordicSki": "Sci di fondo",
  "sport.Padel": "Padel",
  "sport.PhysicalTherapy": "Fisioterapia",
  "sport.Pickleball": "Pickleball",
  "sport.Pilates": "Pilates",
  "sport.Racquetball": "Racquetball",
  "sport.Ride": "Giro in bici",
  "sport.RockClimbing": "Arrampicata",
  "sport.RollerSki": "Skiroll",
  "sport.Rowing": "Canottaggio",
  "sport.Run": "Corsa",
  "sport.Sail": "Vela",
  "sport.Skateboard": "Skateboard",
  "sport.Snowboard": "Snowboard",
  "sport.Snowshoe": "Ciaspole",
  "sport.Soccer": "Calcio",
  "sport.Squash": "Squash",
  "sport.StairStepper": "Stepper",
  "sport.StandUpPaddling": "Stand up paddle",
  "sport.Surfing": "Surf",
  "sport.Swim": "Nuoto",
  "sport.TableTennis": "Tennistavolo",
  "sport.Tennis": "Tennis",
  "sport.TrailRun": "Trail running",
  "sport.Velomobile": "Velomobile",
  "sport.VirtualRide": "Giro in bici virtuale",
  "sport.VirtualRow": "Canottaggio virtuale",
  "sport.VirtualRun": "Corsa virtuale",
  "sport.Volleyball": "Pallavolo",
  "sport.Walk": "Camminata",
  "sport.WeightTraining": "Allenamento con i pesi",
  "sport.Wheelchair": "Sedia a rotelle",
  "sport.Windsurf": "Windsurf",
  "sport.Workout": "Allenamento",
  "sport.Yoga": "Yoga"
}
